import { useMemo, useState } from 'react';

// Status disponíveis com suas cores correspondentes
export const STATUS_OPTIONS = [
  { value: 'Quebrado', label: 'Quebrado', color: 'error' },
  { value: 'Indisponível', label: 'Indisponível', color: 'error' },
  { value: 'Disponível', label: 'Disponível', color: 'info' },
  { value: 'Em Rota Coletando', label: 'Em Rota', color: 'info' },
  { value: 'Foto Recebida', label: 'Foto Recebida', color: 'info' },
  { value: 'Retornando para o Hub', label: 'Retornando ao Hub', color: 'info' },
  { value: 'Concluída', label: 'Concluída', color: 'success' },
  { value: 'Pendente', label: 'Pendente', color: 'warning' },
];

export function useStatusFilter(trips) {
  const [selectedStatuses, setSelectedStatuses] = useState([]);

  // Filtrar trips pelos status selecionados
  const filteredTrips = useMemo(() => {
    if (selectedStatuses.length === 0) {
      return trips;
    }

    return trips.filter(trip => selectedStatuses.includes(trip.status));
  }, [trips, selectedStatuses]);

  // Contar quantas trips existem para cada status
  const statusCounts = useMemo(() => {
    const counts = {};
    STATUS_OPTIONS.forEach(option => {
      counts[option.value] = trips.filter(trip => trip.status === option.value).length;
    });
    return counts;
  }, [trips]);

  // Adicionar ou remover um status dos filtros
  const toggleStatus = (statusValue) => {
    setSelectedStatuses(prev => {
      if (prev.includes(statusValue)) {
        return prev.filter(s => s !== statusValue);
      } else {
        return [...prev, statusValue];
      }
    });
  };

  // Limpar todos os filtros de status
  const clearStatusFilters = () => {
    setSelectedStatuses([]);
  };

  // Verificar se há filtros ativos
  const hasStatusFilters = selectedStatuses.length > 0;

  return {
    selectedStatuses,
    filteredTrips,
    statusCounts,
    toggleStatus,
    clearStatusFilters,
    hasStatusFilters,
    totalResults: filteredTrips.length,
    totalItems: trips.length
  };
} 